import React from 'react';

const HandleErr = ({msg}) => {
    return (
        <div className='err'>
          <h3>{msg}</h3>  
        </div>
    )
}

export default HandleErr;

